import { render, staticRenderFns } from "./NTableNumber.vue?vue&type=template&id=d12b1e34&scoped=true"
import script from "./NTableNumber.vue?vue&type=script&lang=js"
export * from "./NTableNumber.vue?vue&type=script&lang=js"
import style0 from "./NTableNumber.vue?vue&type=style&index=0&id=d12b1e34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d12b1e34",
  null
  
)

export default component.exports